import { SIDE_NAV_WIDE_SETTING } from 'constants/UserSettings';
import { END_ROUTE_LOADING } from 'constants/SideNav';
import { userSettingsActions, currentUserSelectors } from '@lifesize/nucleus';
import _get from 'lodash/get';

export function toggleSideNav() {
  return (dispatch, getState) => {
    const toggleType = _get(currentUserSelectors.myInfo(getState()), ['userSettings', SIDE_NAV_WIDE_SETTING]);
    dispatch(userSettingsActions.updateCurrentUserSettings({ [SIDE_NAV_WIDE_SETTING]: !toggleType }));
  };
}

export function endRouteLoading() {
  return {
    type: END_ROUTE_LOADING
  };
}

export default {
  toggleSideNav,
  endRouteLoading
};
